import React from 'react'
import { Link } from 'react-router-dom'

//style
import '../../assets/css/about-students-new.css'

//images
import videosImage from '../../assets/images/about-students-new/videos.png'
import situationsImage from '../../assets/images/about-students-new/situations.png'
import actorsImage from '../../assets/images/about-students-new/actors.png'
import actorsMobileImage from '../../assets/images/about-students-new/actors-mobile.png'
import testsImage from '../../assets/images/about-students-new/tests.png'
import certificateImage from '../../assets/images/about-students-new/certificate.png'
import iconsImage from '../../assets/images/about-students-new/icons.png'
import topicsImage from '../../assets/images/about-students-new/topics.png'
import statisticsImage from '../../assets/images/about-students-new/statistics.png'
import comunicationImage from '../../assets/images/about-students-new/comunication.png'
import examImage from '../../assets/images/about-students-new/exam.png'
import questionIcon from '../../assets/images/about-students-new/icons/question.png'
import clockIcon from '../../assets/images/about-students-new/icons/clock.png'
import starIcon from '../../assets/images/about-students-new/icons/star.png'
import equalIcon from '../../assets/images/about-students-new/icons/equal.png'

function StudentsNew() {

    return (
        <main id="aboutStudentsMain">
            <section id="aboutStudentsBanner">
                <div className="wrapper">
                    <div className="left-part">
                        <h1>
                            Мултимедийно<br /> учебно помагало
                        </h1>
                        <p>
                            Авто Обучение е учебно помагало за теоретична подготовка на кандидат-шофьори за категория B. Обучението предлага видео лекции подредени по теми, изпитни въпроси за всяка тема с разяснение от Закона за движението по пътищата и провеждане на вътрешен изпит за проверка на знанията. Ползвате Авто Обучение навсякъде от своя телефон, таблет или компютър.
                        </p>
                        <Link to="/register">
                            Започни сега
                        </Link>
                    </div>
                    <div className="right-part">

                    </div>
                </div>
            </section>
            <section id="content">
                <div className="wrapper">
                    <div className="videos">
                        <img src={videosImage} />
                        <div className="right">
                            <h2>
                                Професионални<br /> ВИДЕО ЛЕКЦИИ
                            </h2>
                            <p>
                                Авто Обучение съдържа специално разработени видео уроци за всяка отделна тема
                                по учебната програма. Всички учебни материали са създадени с помощта на
                                преподаватели по теория от цялата страна. Видео лекциите улесняват процеса на
                                запомняне и помагат на курсиста да постигне максимален резултат при
                                усвояването на знания.
                            </p>
                        </div>
                    </div>
                    <div className="situations">
                        <div className="left">
                            <h2>
                                Онагледени<br /> анимирани <br />ситуации
                            </h2>
                            <p>
                                Към всяка видео лекция от учебния материал са разгледани и онагледени примерни
                                ситуации. Анимираните ситуации помагат на кандидат-шофьорите по-лесно да
                                усвоят и запомнят материала, като по този начин да бъдат подготвени и да прилагат
                                уверено правилата при шофиране.
                            </p>
                        </div>
                        <img src={situationsImage} />
                    </div>
                    <div className="with-care">
                        <h2>
                            С подход към курсиста
                        </h2>
                        <p>
                            Всички материали и обяснения са поднесени по начин отговарящ на утвърдените
                            изисквания и подходи за теоретичното обучение. Методологията в Авто Обучение
                            съчетана с ефективни нагледни материали е основа за придобиването на ключови
                            умения при управлението на моторно превозно средство.
                        </p>
                        <img src={actorsImage} className="on-desktop" />
                        <img src={actorsMobileImage} className="on-mobile" />
                    </div>
                    <div className="tests">
                        <img src={testsImage} />
                        <div className="right">
                            <h2>
                                Решаване на тестове<br /> след края на темата
                            </h2>
                            <p>
                                Към всяка тема от учебното съдържание има актуални изпитни тестове с въпроси от самата тема. <b>Всички изпитни въпроси са 100% идентични с въпросите от официалния изпит по теория</b> за придобиване на правоспособност за управление на МПС.
                            </p>
                            <div className="under">
                                <h2>
                                    Разяснение от закона<br /> към всеки въпрос
                                </h2>
                                <p>
                                    Всеки въпрос от изпитните тестове съдържа актуално разяснение от Закона за движение по пътищата и правилника за прилагането му
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="official-documentation">
                        <img src={certificateImage} className="certificate" />
                        <h2>
                            Съгласно официалната учебна<br /> документация
                        </h2>
                        <p>
                            Всички учебни материали в Авто Обучение са изготвени съгласно учебната документация за обучение на кандидатите за придобиване на правоспособност за управление на МПС, утвърдена от Министерство на Образованието и Науката и Изпълнителна Агенция "Автомобилна Администрация". Включени са всички въпроси от официалния изпит по теория.
                        </p>
                        <img src={iconsImage} className="icons" />
                    </div>
                    <div className="topics">
                        <div className="left">
                            <h2>
                                Последователно<br /> обучение в 19 теми
                            </h2>
                            <p>
                                Обучението преминава последователно през всички 19 теми, преминаването към следващата тема се извършва след напълно усвояване на материала от текущата. По този начин кандидат-шофьорите получават гарантирано качествени и трайни знания на пътя.
                            </p>
                        </div>
                        <img src={topicsImage} />
                    </div>
                    <ul className="services">
                        <li>
                            <img src={statisticsImage} />
                            <h2>
                                Статистика за Вашите резултати
                            </h2>
                            <p>
                                След започване на обучението, системата показва статистика, чрез която курсистите следят своя напредък в Авто Обучение.
                            </p>
                        </li>
                        <li>
                            <img src={comunicationImage} />
                            <h2>
                                Комуникация с Вашият преподавател
                            </h2>
                            <p>
                                По време на обучение курсиста има възможност да зададе въпрос свързан с конкретната тема, по която се обучава директно в Авто Обучение.
                            </p>
                        </li>
                    </ul>
                    <div className="exam">
                        <img src={examImage} />
                        <div className="right">
                            <h2>
                                Изпит идентичен с официалния
                            </h2>
                            <p>
                                След успешното преминаване през всички 19 теми, Авто Обучение стартира изпит идентичен с официалния изпит по теория. Курсистът решава изпитни въпроси в режим изпит колкото пъти е необходимо.
                            </p>
                            <ul className="under">
                                <li>
                                    <img src={questionIcon} />
                                    <h2>
                                        45
                                    </h2>
                                    <h3>
                                        ВЪПРОСА
                                    </h3>
                                </li>
                                <li>
                                    <img src={clockIcon} />
                                    <h2>
                                        40
                                    </h2>
                                    <h3>
                                        МИНУТИ
                                    </h3>
                                </li>
                                <li>
                                    <img src={starIcon} />
                                    <h2>
                                        97
                                    </h2>
                                    <h3>
                                        ТОЧКИ
                                    </h3>
                                </li>
                                <li>
                                    <img src={equalIcon} />
                                    <h2>
                                        100%
                                    </h2>
                                    <h3>
                                        идентичност с
                                        <br />
                                        официалните въпроси
                                    </h3>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section id="aboutStart">
                <div className="pannel">
                    <h2>
                        Започнете обучението си сега
                    </h2>
                    <p>
                        Регистрирайте се и може да започнете веднага своето обучение и решаването на изпитни тестове.
                    </p>
                    <Link to="/register">
                        Започни сега
                    </Link>
                </div>
            </section>
        </main>
    )
}

export default StudentsNew